<p *ngIf="heading" a-style fs="1.4" fw="500" color="#333333" mb="1.6"> {{heading}} </p>
<div a-style br="1px solid #e2e2e2" p="1.6" mb="2.4">
    <p *ngIf="title" a-style fs="1.3"  [mb]="mb? mb:'1'" color="#333333"> {{title}}</p>
    <ng-content></ng-content>
</div>